<template>
  <div>
	<make-donation-widget
	  slot="body"
	  :campaign-id="campaignId"
	  :key="`gen_don_` + campaignId"
	  :should-open-modal="true"
	></make-donation-widget>
  </div>
</template>

<script>
import MakeDonationWidget from './MakeDonationWidget';

export default {
  components: {
	MakeDonationWidget,
  },
  props: {
	campaignId: {
	  type: String,
	  required: true,
	},
  },
};
</script>